<div class="lab">
  <div class="menu">
    <div class="header">
      <mat-icon class="material-icons-outlined"> science </mat-icon>
      <h3>Laboratory</h3>
    </div>
    <div class="menu-items">
      <a routerLink="/lab/unprocessed" routerLinkActive="active" class="menu-item">
        <mat-icon class="material-icons-outlined">upload</mat-icon><span>Unprocessed Images</span>
      </a>
      <a routerLink="/lab/processed" routerLinkActive="active" class="menu-item">
        <mat-icon class="material-icons-outlined">task_alt</mat-icon><span>Processed Images</span>
      </a>
      <a routerLink="/lab/library" routerLinkActive="active" class="menu-item">
        <mat-icon class="material-icons-outlined">photo_library</mat-icon><span>Library</span>
      </a>
    </div>
  </div>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>